import React from "react";
import "../../assets/styles/components/textfield.scss";

interface Props {
  title?: string;
  id?: string;
  className?: string;
  children?: object;
  isChecked?: boolean;
  name?: string;
  disabled?: boolean;
  style?: object;
  labelsStyle?: object;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxText: React.FC<Props> = ({
  className,
  onChange,
  children,
  isChecked,
  title,
  name,
  id,
  style,
  labelsStyle,
  disabled = false,
}) => {
  let attributes = Object.assign({});
  attributes.className = `check-box ${className || ""}`;
  return (
    <div {...attributes} style={{ cursor: "pointer", alignItems: "center", ...style }}>
      <input
        type="checkbox"
        id={id}
        name={name}
        style={{ marginTop: "3px", cursor: "pointer" }}
        onChange={onChange}
        checked={isChecked}
        className="form-check-input"
        value={title}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        style={{ marginLeft: "10px", cursor: "pointer", alignItems: "end", ...labelsStyle }}
      >
        {title}
      </label>
      {children}
    </div>
  );
};
export default CheckboxText;
